import { Link, Typography } from '@mui/material'
import { WithRouterProps } from 'next/dist/client/with-router'
import { withRouter } from 'next/router'
import * as React from 'react'
import LoginComponent from './LoginComponent'
import MuiLink from '@mui/material/Link'
import RegisterStudentComponent from './RegisterStudentComponent'
import RegisterTeacherComponent from '@/components/Auhentication/LoginComponent/RegisterTeacherComponent'
import { IUserType } from '../../../interfaces/user.interface'

interface IAuthProps extends WithRouterProps {
  isDialog?: boolean
  school_details: any
  onSuccess: () => void
}

const AuthComponentTabs = (props: IAuthProps) => {
  const [tabValue, setTabValue] = React.useState<number>(0) // change default tab from signup to login on the school login page/drawer
  const [errorMessage, setErrorMessage] = React.useState<string>('')
  const [email, setEmail] = React.useState<string>()
  const [userData, setUserData] = React.useState<any>()

  const changeToSignupTab = (opts: {
    email: string
    userData?: any
    userType: IUserType | ''
  }) => {
    setErrorMessage('')
    console.log({ opts })
    let localTabV
    switch (opts.userType) {
      case 'student':
        localTabV = 1
        break
      case 'teacher':
        localTabV = 2
        break
      default:
        localTabV = 1
    }

    if (opts?.email) {
      setEmail(opts.email)
    }
    opts?.userData && setUserData(opts.userData)
    setTabValue(localTabV)
  }

  const changeToLoginTab = () => {
    setTabValue(0)
  }

  return (
    <div
      style={{
        position: 'relative',
        padding: '20px',
        backgroundColor: 'rgb(244, 245, 247)',
        minHeight: '100vh',
      }}
    >
      <div
        style={{ maxWidth: '400px', minHeight: '500px', margin: '20vh auto 0' }}
      >
        <div>
          {tabValue === 0 && (
            <div style={{ marginBottom: '10px' }}>
              <Link href={'/'}>
                {props.school_details.logo && (
                  <img
                    src={props.school_details.logo}
                    style={{ height: '50px', marginBottom: '6px' }}
                  />
                )}
              </Link>
              <Typography
                style={{ fontWeight: 500 }}
                gutterBottom={true}
                variant={'h4'}
              >
                Welcome
              </Typography>
              <Typography
                gutterBottom={true}
                style={{ fontWeight: 'bold' }}
                variant={'body2'}
              >
                to {props.school_details.name}
              </Typography>
              <Typography gutterBottom={true} variant={'body2'}>
                {props.school_details.tagline}
              </Typography>
              <LoginComponent
                goToSignup={changeToSignupTab}
                isDialog={!!props.isDialog}
                setErrorMessage={setErrorMessage}
                onSuccess={() => {
                  props.onSuccess()
                }}
                school_details={props.school_details}
              />
            </div>
          )}
        </div>

        <div style={{ maxWidth: '400px', marginTop: '10px' }}>
          {tabValue === 1 && (
            <div style={{ marginBottom: '10px' }}>
              <Link href={'/'}>
                {props.school_details.logo && (
                  <img
                    src={props.school_details.logo}
                    style={{ height: '50px', marginBottom: '6px' }}
                  />
                )}
              </Link>
              <Typography
                style={{ fontWeight: 500 }}
                gutterBottom={true}
                variant={'h4'}
              >
                Sign up
              </Typography>
              <Typography style={{ fontWeight: 'bold' }} variant={'body2'}>
                as a <span style={{ fontWeight: 'bold' }}> student </span> to{' '}
                {props.school_details.name}
              </Typography>

              <>
                <div>
                  <Typography gutterBottom={true} variant={'body2'}>
                    Already have an account?
                    <MuiLink
                      onClick={changeToLoginTab}
                      color="primary"
                      style={{ marginLeft: '5px' }}
                    >
                      <b>Sign in</b>
                    </MuiLink>
                  </Typography>
                </div>
                <RegisterStudentComponent
                  isDialog={!!props.isDialog}
                  setErrorMessage={setErrorMessage}
                  onSuccess={() => {
                    props.onSuccess()
                  }}
                  school_details={props.school_details}
                  prefill={{ email: email, userData: userData }}
                  // goToLogin={changeToLoginTab}
                />
              </>
            </div>
          )}

          {tabValue === 2 && (
            <div style={{ marginBottom: '10px' }}>
              <Link href={'/'}>
                {props.school_details.logo && (
                  <img
                    src={props.school_details.logo}
                    style={{ height: '50px', marginBottom: '6px' }}
                  />
                )}
              </Link>
              <Typography
                style={{ fontWeight: 500 }}
                gutterBottom={true}
                variant={'h4'}
              >
                Sign up
              </Typography>
              <Typography variant={'body2'}>
                as a <span style={{ fontWeight: 'bold' }}> teacher </span> to{' '}
                {props.school_details.name}
              </Typography>

              <>
                <div>
                  <Typography gutterBottom={true} variant={'body2'}>
                    Already have an account?
                    <MuiLink
                      onClick={changeToLoginTab}
                      color="primary"
                      style={{ marginLeft: '5px' }}
                    >
                      <b>Sign in</b>
                    </MuiLink>
                  </Typography>
                </div>
                <RegisterTeacherComponent
                  isDialog={!!props.isDialog}
                  setErrorMessage={setErrorMessage}
                  onSuccess={() => {
                    props.onSuccess()
                  }}
                  school_details={props.school_details}
                  prefill={{ email: email, userData: userData }}
                  // goToLogin={changeToLoginTab}
                />
              </>
            </div>
          )}
        </div>
        {errorMessage && (
          <div style={{ marginTop: '20px' }}>
            <Typography
              align={'center'}
              variant={'body2'}
              color="error"
              gutterBottom={true}
            >
              {errorMessage}
            </Typography>
          </div>
        )}
      </div>
    </div>
  )
}

export default withRouter(AuthComponentTabs)
